import { Action } from "@/src/data/types";
import { CalendarClock } from "lucide-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getActionBySlug } from "../../../src/API/Actions/actionService";
const IniativeSinglePage = () => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  const { slug } = useParams();
  const [data, setData] = useState<Action>();
  useEffect(() => {
    const fetchData = async () => {
      if (slug) {
        const data = await getActionBySlug(slug);
        setData(data);
      }
    };

    if (slug) {
      fetchData();
    }
  }, [slug]);

  return (
    <div className="mt-10 ">
      {" "}
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <div className="mt-5">
          <h1 className="text-2xl font-bold text-black">
            {(data && data?.title) || "Titre"}
          </h1>
          <div className="flex mt-2 space-x-3">
            <div>
              <CalendarClock className="text-primary" />
            </div>
            <div className="text-black ">
              {(data &&
                new Date(data.date).toLocaleDateString("fr-FR", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })) ||
                new Date().toLocaleDateString("fr-FR")}
            </div>
          </div>

          <hr className="w-full h-1 mt-2 bg-primary" />
        </div>

        <div className="mt-5">
          {data && (
            <img src={`${uploadUrl}/initiatives/${data.image}`} alt="" />
          )}
        </div>

        <div className="mt-10">
          {data && data.description && (
            <div dangerouslySetInnerHTML={{ __html: data.description }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default IniativeSinglePage;
